import { render, staticRenderFns } from "./ChallengesMessagerie.vue?vue&type=template&id=feb4a704&"
import script from "./ChallengesMessagerie.vue?vue&type=script&lang=js&"
export * from "./ChallengesMessagerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports